// extracted by mini-css-extract-plugin
export default {"fullWrap":"MasterMobi_fullWrap__xuVY6","WebPage":"MasterMobi_WebPage__Hi+uq","MasterBottom":"MasterMobi_MasterBottom__MRFZd","MasterTop":"MasterMobi_MasterTop__o5yCJ"};